













































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import {
  ProductTabFilterOptions,
  PageConfig,
  TransactionSearchOptions
} from "../../types";
import ProductTable from "../ProductTable.vue";
import SKUNameRenderer from "../TableRenderers/SKUNameRenderer.vue";
import AvailabilityRenderer from "../TableRenderers/AvailabilityRenderer.vue";
import TableActionRenderer from "../TableRenderers/TableActionRenderer.vue";
import SamplesTableActionRenderer from "./SamplesTableActionRenderer.vue";
import ReturnSampleModal from "./ReturnSample.vue";
import IssueSampleModal from "./IssueSample.vue";
import SampleAvailabilityRenderer from "./SampleAvailabilityRenderer.vue";
import NameRenderer from "../TableRenderers/NameRenderer.vue";
import SampleInfoModal from "./SampleInfo.vue";
import { dateToTime } from "@/utils";

export default Vue.extend({
  components: {
    ProductTable,
    SKUNameRenderer,
    AvailabilityRenderer,
    TableActionRenderer
  },
  name: "manage-samples",
  data(): { [key: string]: any } {
    return {
      compModalElement: {
        isVisible: false,
        isClosable: false,
        title: "",
        type: "",
        content: "",
        renderComponent: null,
        data: {}
      },
      searchedData: {},
      samplesTabItems: ProductTabFilterOptions,
      activeTab: ProductTabFilterOptions[0],
      samplesTable: {
        columns: [
          {
            name: "sample_id",
            display_name: "SAMPLE ID",
            fixed: false,
            width: 25,
            headrenderer: null,
            cellrenderer: NameRenderer
          },
          {
            name: "condition",
            display_name: "CONDITION",
            sortable: false,
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: NameRenderer
          },
          {
            name: "location",
            display_name: "LOCATION",
            sortable: false,
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: NameRenderer
          },
          {
            name: "availability",
            display_name: "AVAILABILITY",
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: SampleAvailabilityRenderer
          },
          {
            name: "action",
            display_name: "Actions",
            fixed: false,
            width: 15,
            headrenderer: null,
            cellrenderer: SamplesTableActionRenderer
          }
        ]
      }
    };
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction,
      modalDoneAction: this.modalDoneAction
    };
  },
  computed: {
    ...mapState("appModule", {
      user: "loggedInUser",
      selectedEc: "selectedEc",
      samplesTableData: "inventorySampleDetails"
    }),
    ...mapState("uiModule", {
      modalElement: "modalElement"
    })
  },
  methods: {
    ...mapActions("appModule", [
      "searchInventorySamples",
      "issueInventorySample",
      "returnInventorySample",
      "downloadTemplatePdf"
    ]),
    tabClicked(eventData: { tabKey: string }): void {
      this.activeTab = this.samplesTabItems.find((tabItem: { key: string }) => {
        return tabItem.key === eventData.tabKey;
      });
      this.updateRoute();
    },
    updateRoute() {
      const query = {
        sku_code: this.searchedData.sku_code,
        status: this.activeTab.name,
        limit: this.samplesTableData.pageConfig.limit,
        offset: this.samplesTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.samplesTableData.pageConfig.query = encodeQueryParams(query);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/inventory/" +
        this.$router.currentRoute.params.searchQuery +
        "/" +
        this.$router.currentRoute.params.productQuery +
        "/" +
        JSON.stringify({
          data: this.searchedData.name,
          sku_code: this.searchedData.sku_code,
          status: this.activeTab,
          pageConfig: this.samplesTableData.pageConfig
        }) +
        "/samples";
      this.$router.push({
        path: routeLink
      });
    },
    actionOnSamplesEdit() {
      const finishEditUrl =
        "/" +
        this.selectedEc.name +
        "/add/" +
        JSON.parse(this.$router.currentRoute.params.productQuery).sku_code +
        "/finishes/" +
        this.searchedData.sku_code;
      this.$store.commit("appModule/resetBreadcrumb");
      this.$router.push({
        path: finishEditUrl
      });
    },
    modalDoneAction(type: "issue" | "return") {
      let transformRequest: {};
      switch (type) {
        case "issue":
          transformRequest = {
            inventory_id: this.compModalElement.data.inventory_id,
            unique_code: this.compModalElement.data.sample_id,
            issued_to: this.compModalElement.data.designer.name,
            issue_remarks: this.compModalElement.data.issue_remarks,
            issue_condition: this.compModalElement.data.issue_condition.name,
            expected_return_date: dateToTime(this.compModalElement.data.date),
            ec_id: this.selectedEc.name,
            issue_date: dateToTime(new Date())
          };
          this.handleWithDecorationAction(() => {
            return this.issueSample(transformRequest);
          }, this.modalElement).then(() => {
            this.$store.dispatch("uiModule/addToast", {
              severity: "success",
              message:
                "Sample " +
                this.compModalElement.data.sample_id +
                " issued successfully"
            });
            this.onSamplesSearch();
            this.compModalElement.data.isVisible = false;
          });
          // .catch((err: { error: string }) => {
          //   this.compModalElement.isVisible = false;
          // });
          break;
        case "return":
          transformRequest = {
            inventory_id: this.compModalElement.data.inventory_id,
            data: {
              return_condition: this.compModalElement.data.return_condition
                .name,
              return_remarks: this.compModalElement.data.return_remarks
            }
          };
          this.handleWithDecorationAction(() => {
            return this.returnSample(
              transformRequest as { inventory_id: number; data: object }
            );
          }, this.modalElement).then(() => {
            this.$store.dispatch("uiModule/addToast", {
              severity: "success",
              message:
                "Sample " +
                this.compModalElement.data.sample_id +
                " returned successfully"
            });
            this.onSamplesSearch();
            this.compModalElement.data.isVisible = false;
          });
          // .catch((err: { error: string }) => {
          //   this.compModalElement.isVisible = false;
          // });
          break;
      }
    },
    issueSample(request: { [key: string]: any }) {
      return this.issueInventorySample(request);
    },
    returnSample(request: { inventory_id: number; data: object }) {
      return this.returnInventorySample(request);
    },
    onSamplesSearch() {
      this.handleWithDecorationAction(() => {
        return this.searchSamples();
      }, this.modalElement).then(() => {});
    },
    searchSamples() {
      const query = {
        sku_code: this.searchedData.sku_code,
        status: this.activeTab.name,
        limit: this.samplesTableData.pageConfig.limit,
        offset: this.samplesTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.samplesTableData.pageConfig.query = encodeQueryParams(query);
      return this.searchInventorySamples(this.samplesTableData.pageConfig);
    },
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "return":
          //open modal for request
          this.compModalElement = Object.assign(this.compModalElement, {
            renderComponent: ReturnSampleModal,
            data: {
              isVisible: true,
              title: "Return Sample - " + data.sample_id,
              type: "return",
              sample_id: data.sample_id,
              inventory_id: data.inventory_id,
              issued_to: data.issued_to,
              issue_condition: data.issue_condition,
              issue_remarks: data.issue_remarks,
              return_remarks: "",
              return_condition: {
                name: "",
                display_name: ""
              }
            }
          });
          this.actionData = {};
          break;
        case "issue":
          this.compModalElement = Object.assign(this.compModalElement, {
            renderComponent: IssueSampleModal,
            data: {
              isVisible: true,
              title: "Issue Sample - " + data.sample_id,
              type: "issue",
              sample_id: data.sample_id,
              inventory_id: data.inventory_id,
              designer: {
                name: "",
                display_name: ""
              },
              date: null,
              issue_condition: JSON.parse(JSON.stringify(data.condition)),
              issue_remarks: ""
            }
          });
          break;
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.samplesTableData.pageConfig.offset =
            this.samplesTableData.pageConfig.limit * (data - 1);
          this.samplesTableData.pageConfig.page = data;
          this.updateRoute();
          break;
        case "setPageLength":
          this.samplesTableData.pageConfig.limit = data;
          this.samplesTableData.pageConfig.page = 1;
          this.samplesTableData.pageConfig.offset = 0;
          this.updateRoute();
          break;
        case "viewhistory":
          this.viewSampleHistory(data.sample_id);
          break;
        case "details":
            this.$store.dispatch("appModule/trackSegementEvents", {
            eventName: "VIEW_ALL_ITEM_DETAILS",
            properties: { ec_id: this.selectedEc.name, user_id :this.user.id, timestamp: new Date(), sample_sku: data.name,sample_unique_id: data.sample_id }
            });
            this.compModalElement = Object.assign(this.compModalElement, {
            renderComponent: SampleInfoModal,
            data: {
              isVisible: true,
              title: "Sample Details",
              details: [
                  {
                      "title": "Sample ID",
                      "value": data.sample_id
                  },
                  {
                      "title": "Sample Type",
                      "value": data.name
                  },
                  {
                      "title": "Sample Location",
                      "value": data.location
                  },
                  {
                      "title": "Sample Added on",
                      "value": data.created_at
                  }
              ]
            }
          });
          break;
          case "download":
         this.$store.dispatch("appModule/trackSegementEvents", {
            eventName: "DOWNLOAD_SINGLE_LABEL",
            properties: { ec_id: this.selectedEc.name, user_id :this.user.id, timestamp: new Date(), sample_sku: data.name,sample_unique_id: data.sample_id }
         });
         this.transformAndDownloadPDF(data);
         break;
      }
    },
    viewSampleHistory(unique_code: number | string) {
      let lendingPageConfig = PageConfig;
      const apiQuery = {
        unique_code: unique_code,
        limit: lendingPageConfig.limit,
        offset: lendingPageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      lendingPageConfig.query = encodeQueryParams(apiQuery);
      const lendingsUrl =
        "/" +
        this.selectedEc.name +
        "/trxnhistory/" +
        JSON.stringify({
          search: {
            searchText: unique_code.toString(),
            option: TransactionSearchOptions[0]
          },
          designerSearch: { name: "", display_name: "" },
          pageConfig: lendingPageConfig
        });
      this.$store.commit("appModule/resetBreadcrumb");

      this.$router.push({
        path: lendingsUrl
      });
    },
    handleWithDecorationAction(
      asyncFunc: (...args: any) => Promise<any>,
      modal: { isVisible: boolean; content: string; type: string }
    ) {
      modal.isVisible = true;
      modal.type = "loading";
      return asyncFunc
        .apply(arguments)
        .then(response => {
          modal.isVisible = false;
          return response;
        })
        .catch((err: { error: string }) => {
          modal.isVisible = false;
          this.$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: err.error,
            duration: 0
          });
          throw err;
        });
    },
    initManageSamples() {
      const parsedJSONData = JSON.parse(
        this.$router.currentRoute.params.skuQuery
      );
      this.$store.dispatch("appModule/updateBreadcrumb", {
        data: {
          name: "samples",
          display_name: parsedJSONData.data,
          href: "",
          routerLink: this.$router.currentRoute.path
        },
        router: this.$router
      });
      this.searchedData = {
        name: parsedJSONData.data,
        sku_code: parsedJSONData.sku_code
      };
      this.samplesTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      this.activeTab = parsedJSONData.status
        ? parsedJSONData.status
        : this.samplesTabItems[0];
    },
      transformAndDownloadPDF(data: { [key: string]: any }) {
        const results = { samples: [{
            sample_id: data.sample_id.substring(0, 35),
            location: data.location.substring(0, 35)
        }]}
      this.downloadTemplatePdf(results).then((resp:any) => {
        resp.blob().then((body: any) => {
          const fileURL = URL.createObjectURL(body);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = "samples-" + new Date().getTime().toString() + ".pdf";
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          window.addEventListener("focus", e => URL.revokeObjectURL(link.href), {
            once: true
          });
        });
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      this.initManageSamples();
      this.onSamplesSearch();
    }
  },
  mounted() {
    this.initManageSamples();
  }
});
